import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IntentValuesType } from 'Deer/intent/types/IntentCommonTypes';
import { useSelector } from 'react-redux';

export type Company = {
  id: string;
  companyName: string;
};

export type PointsIntentType = {
  id: string;
  label: string;
  onClick: () => void;
  visible: () => boolean;
  isBeta?: boolean;
  category: string;
  value: {
    myData?: IntentValuesType;
    team?: {
      directReports: IntentValuesType;
      allReports: IntentValuesType;
    };
    company?: IntentValuesType;
  };
  hasMetaFilters?: boolean;
};

const initialState: {
  selectedIntent: null | PointsIntentType;
  selectedCompanies: Company[];
  allCompanies: Company[];
  selectedLocations: string[];
  allLocations: string[];
} = {
  selectedIntent: null,
  selectedCompanies: [],
  allCompanies: [],
  selectedLocations: [],
  allLocations: [],
};

export const pointsIntentSlice = createSlice({
  name: 'pointsIntent',
  initialState,
  reducers: {
    setSelectedPointsIntent: (state, action: PayloadAction<PointsIntentType>) => {
      state.selectedIntent = action.payload;
    },
    setSelectedCompanies: (state, action: PayloadAction<Company[]>) => {
      state.selectedCompanies = action.payload;
    },
    setAllCompanies: (state, action: PayloadAction<Company[]>) => {
      state.allCompanies = action.payload;
    },
    setSelectedLocations: (state, action: PayloadAction<string[]>) => {
      state.selectedLocations = action.payload;
    },
    setAllLocations: (state, action: PayloadAction<string[]>) => {
      state.allLocations = action.payload;
    },
  },
});

export const { setSelectedPointsIntent, setSelectedCompanies, setAllCompanies, setSelectedLocations, setAllLocations } =
  pointsIntentSlice.actions;

export default pointsIntentSlice.reducer;

export const useSelectPointsSelectedIntent = () =>
  useSelector((state: { pointsIntent: typeof initialState }) => state.pointsIntent.selectedIntent);

export const useSelectedPointsCompanies = () =>
  useSelector((state: { pointsIntent: typeof initialState }) => state.pointsIntent.selectedCompanies);

export const useAllPointsCompanies = () =>
  useSelector((state: { pointsIntent: typeof initialState }) => state.pointsIntent.allCompanies);

export const useSelectedPointsLocations = () =>
  useSelector((state: { pointsIntent: typeof initialState }) => state.pointsIntent.selectedLocations);

export const useAllPointsLocations = () =>
  useSelector((state: { pointsIntent: typeof initialState }) => state.pointsIntent.allLocations);
